













































import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import AdminNavBar from './AdminNavBar.vue';
import {Action, Mutation, namespace, Getter, State} from 'vuex-class';
import {ReviewRate} from '@/store/RateReviewFaq/types';
import {DateTime} from 'luxon';
import { rateState } from '../../store/RateReviewFaq';
import BTable from 'buefy/src/components/table/Table.vue';
import * as firebase from 'firebase/app';
import {MAFUser} from '@/store/User/types';

const reviewsPath = 'rateState';
const reviewsNamespace = namespace(reviewsPath);

const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
        components: {
            AdminNavBar, BTable,
        },
    })
 export default class AdminReviews extends Vue {
    @reviewsNamespace.State('reviewRate') public Reviews !: ReviewRate[];
    @reviewsNamespace.Action('getReviews') public getReviews: any;


    public currentPage: number = 1;
    public checkboxPosition: any = 'left';
    public hasMobileCards: boolean = true;
    public showInteraction: boolean = false;
    public defaultSortDirection: any = 'desc';
    public async created() {
            await this.getReviews();
        }
    public formatDate(date: Date) {
            return DateTime.fromJSDate(date).toFormat(' LLLL d yyyy t');
        }
    public capitalize(name: string, userType: string) {
        if (userType === 'Organization') {
            return name;
        } else {
            const nameArray = name.split(' ');
            const firstName = nameArray[0].charAt(0).toUpperCase() + nameArray[0].slice(1);
            if (nameArray.length === 1) { return firstName; }
            if (nameArray.length > 1) {
                return `${firstName} ${(nameArray[1][0]) ?
                    nameArray[1][0].toUpperCase() + '.' : ''}`;
            }
            if (nameArray.length < 1) { return 'No Name'; }
        }
    }
 }
